export const selectManualEntryList = (state) =>
    state.manualEntry.manualEntryData;

export const selectManualEntryLoading = (state) =>
    state.manualEntry.status === "loading";
